module.exports = __webpack_public_path__ + "img/maria-emilia-iturralde.ac84581a.jpg";